export const phoneRegex =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

export const zipCodeRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;

export const npiRegex = /^\d{10}$/;
